import React from "react";
import { useSelector } from "react-redux";
import { selectAllQuestionsForRound } from "features/question/questionSlice";
import { selectGameObject } from "features/gamestate/gameStateSlice";
import { GAMESTATE_ROUND_FINAL } from "features/gamestate/constants";
import EditorCategoryCell from "./EditorCategoryCell";
import EditorValueCell from "./EditorValueCell";
import { selectPanelMode, selectSelectedQuestionId } from "./editorSlice";
import "./roundEditor.css";

const FinalRoundBoard = () => {
  const gameObject = useSelector(selectGameObject);
  const questions = useSelector(
    selectAllQuestionsForRound(GAMESTATE_ROUND_FINAL)
  );
  const panelMode = useSelector(selectPanelMode);
  const selectedQuestionId = useSelector(selectSelectedQuestionId);
  const hasSpotlight = panelMode === "clue" && !!selectedQuestionId;
  const finalCat = gameObject?.categories?.final;
  const categoryLabel = finalCat?.category || "Final Jeopardy";
  const finalQuestion = questions?.question || null;
  const finalQuestionId = finalCat?.question || finalQuestion?.id;
  const written =
    finalQuestion?.clue?.trim() &&
    Array.isArray(finalQuestion?.answers) &&
    finalQuestion.answers.some((a) => a?.trim())
      ? 1
      : 0;

  return (
    <div
      className={`re-board re-board--final ${hasSpotlight ? "has-spotlight" : ""}`}
      style={{ "--re-cols": 1 }}
    >
      <EditorCategoryCell
        label={categoryLabel}
        categoryIdx={0}
        round={GAMESTATE_ROUND_FINAL}
        clueCount={written}
        maxFont={44}
      />
      <EditorValueCell
        question={finalQuestion}
        questionId={finalQuestionId}
        rowIndex={0}
        round={GAMESTATE_ROUND_FINAL}
        isFinal
      />
      <div
        className={`re-board-scrim ${hasSpotlight ? "active" : ""}`}
        aria-hidden="true"
      />
    </div>
  );
};

export default FinalRoundBoard;
